import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
  Stack,
} from '@mui/material';

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean,
  square?: boolean,
  testID: string,
  uppercase?: boolean,
}

export const Button = ({
  children,
  disabled,
  loading,
  size,
  square = false,
  sx,
  testID,
  uppercase,
  ...rest
}: ButtonProps) => {

  return (
    <MuiButton
      data-testid={testID}
      disabled={loading || disabled}
      focusRipple={false}
      size={size}
      sx={[{
        ...square ? { padding: "8px 10px" } : {},
        borderRadius: square ? "4px" : "8px",
        textTransform: uppercase ? 'uppercase' : '',
        minWidth: 'auto',
        whiteSpace: 'nowrap',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      <>
        {
          loading && <CircularProgress size={20} style={{
            position: "absolute",
            left: 0,
            right: 0,
            marginLeft: "auto",
            marginRight: "auto",
          }} />
        }
        <Stack
          alignItems="center"
          direction="row"
          style={{
            padding: square ? "0px 4px" : "0px 8px",
            visibility: loading ? "hidden" : "visible",
          }}
        >
          {children}
        </Stack>
      </>
    </MuiButton>
  );
};
